import React from "react";
import Header from '../components/Header.js';

export default function Contacto(props){


	  return(
	  	<div>

	  		<Header modelos={props.modelos}/>

	  		<div className="container center-align" style={{marginTop : "80px", marginBottom : "80px"}}>
	  			<h4 className="fontRegular" style={{color:"black"}}>Si queres saber mas sobre 0km Cero Vueltas, 
	  			no dudes en comunicarte	con nosotros al: 
	  			<br /><br /><b>011-4505-8604</b></h4>
	  		</div>


	  	</div>
	);
}